module.exports = __webpack_public_path__ + "media/images/icons/check-6842dfd59d2dbca976a1eb850fe84ffa.svg";